export default "__VITE_ASSET__51830735__"